<div class="info">

    <ng-content></ng-content>
</div>
